import React from 'react';
import PropTypes from 'prop-types';
const get = require('lodash/get');

const propTypes = {
    error: PropTypes.shape({
        message: PropTypes.string,
        responseText: PropTypes.string,
        stack: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    }),
    allowStackTrace: PropTypes.bool,
    className: PropTypes.string,
    onClose: PropTypes.func,
};

const defaultProps = {
    error: null,
    allowStackTrace: false,
    className: '',
    onClose: null,
};

class ErrorBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showStack: false
        };

        this.toggleStack = this.toggleStack.bind(this);
    }

    toggleStack() {
        this.setState({ showStack: !this.state.showStack });
    }

    render() {
        if (!this.props.error) {
            return null;
        }

        const stack = get(this.props.error, 'stack', null);
        return (
          <div className={`error-box alert alert-danger ${this.props.className}`} role="alert">
            {!!this.props.onClose &&
                <div className="fr">
                    <button className="bare-text-button glyph" onClick={this.props.onClose}>
                        <span className="fa fa-remove" aria-hidden />
                        <span className="sr-only">Close</span>
                    </button>
                </div>
            }
            <span className="fa fa-exclamation-circle" aria-hidden />
            <span className="sr-only">Error:</span>
            <span id="text"> {this.props.error.message || this.props.error.responseText}</span>
            {(this.props.allowStackTrace && !!stack) &&
                <button
                    className="bare-text-button glyph fr"
                    onClick={this.toggleStack}
                >
                    {(this.state.showStack) ?
                        <span>
                            <span className="fa fa-chevron-down" />
                            <span className="sr-only">Hide Error Stack</span>
                        </span>
                        :
                        <span>
                            <span className="fa fa-chevron-right" />
                            <span className="sr-only">Show Error Stack</span>
                        </span>
                    }
                </button>
            }
            {(this.state.showStack) &&
                <div className="text-left text-fixed-w text-small">
                    {stack}
                </div>
            }
          </div>
        );
    }
}

ErrorBox.propTypes = propTypes;
ErrorBox.defaultProps = defaultProps;

export default ErrorBox;
